<template>
  <div class="root">
    <transition :name="transitionName" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import dayjs from "dayjs";

const DEFAULT_TRANSITION = "fade";
import { mapActions } from "vuex";

export default {
  name: "App",
  data: () => ({
    transitionName: DEFAULT_TRANSITION,
  }),
  methods: {
    ...mapActions([
      "setPlayerName",
      "setPlayerEmail",
      "setStartDateWeek",
      "setEndDateWeek",
      "alreadyPlay",
    ]),
  },
  created() {
    if (this.$route.query.playerName) {
      this.setPlayerName(this.$route.query.playerName);
    }
    if (this.$route.query.email) {
      this.setPlayerEmail(this.$route.query.email);
    }
    if (this.$route.query.isAllowedToPlay) {
      const canPlay =
        this.$route.query.isAllowedToPlay == "undefined"
          ? false
          : this.$route.query.isAllowedToPlay == "true";
      this.alreadyPlay(!canPlay);
    }

    if (
      this.$route.query.startDate &&
      this.$route.query.startDate == "undefined"
    ) {
      this.$route.query.startDate = undefined;
    }

    if (this.$route.query.endDate && this.$route.query.endDate == "undefined") {
      this.$route.query.endDate = undefined;
    }

    const startDateWeek =
      this.$route.query.startDate ?? dayjs().startOf("week");
    const endDateWeek = this.$route.query.endDate ?? dayjs().endOf("week");

    this.setStartDateWeek(startDateWeek);
    this.setEndDateWeek(endDateWeek);
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === "slide") {
        const toDepth = to.meta.id;
        const fromDepth = from ? from.meta.id : 0;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },
};
</script>

<style lang="scss">
@import "./scss/animations.scss";

.root {
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
